export const FONTSIZES = {
  title: '3rem',
  heroName: '4rem',
  p: '2rem',
  cards: '1.5rem',
};

export const SIZES = {
  small: '1rem',
  medium: '1.5rem',
  large: '2rem',
  xlarge: '3rem',
  xxlarge: '5rem',
};

export const BG = {
  heroDetailsImg: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='600' preserveAspectRatio='none' viewBox='0 0 1440 600'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1101%26quot%3b)' fill='none'%3e%3crect width='1440' height='600' x='0' y='0' fill='rgba(0%2c 0%2c 0%2c 0.99)'%3e%3c/rect%3e%3cpath d='M65 600L665 0L1068.5 0L468.5 600z' fill='url(%23SvgjsLinearGradient1102)'%3e%3c/path%3e%3cpath d='M542.2 600L1142.2 0L1295.2 0L695.2 600z' fill='url(%23SvgjsLinearGradient1102)'%3e%3c/path%3e%3cpath d='M1371 600L771 0L252 0L852 600z' fill='url(%23SvgjsLinearGradient1103)'%3e%3c/path%3e%3cpath d='M961.8 600L361.79999999999995 0L90.29999999999995 0L690.3 600z' fill='url(%23SvgjsLinearGradient1103)'%3e%3c/path%3e%3cpath d='M1085.9606264895563 600L1440 245.96062648955632L1440 600z' fill='url(%23SvgjsLinearGradient1102)'%3e%3c/path%3e%3cpath d='M0 600L354.0393735104437 600L 0 245.96062648955632z' fill='url(%23SvgjsLinearGradient1103)'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1101'%3e%3crect width='1440' height='600' fill='white'%3e%3c/rect%3e%3c/mask%3e%3clinearGradient x1='0%25' y1='100%25' x2='100%25' y2='0%25' id='SvgjsLinearGradient1102'%3e%3cstop stop-color='rgba(255%2c 0%2c 0%2c 0.04)' offset='0'%3e%3c/stop%3e%3cstop stop-opacity='0' stop-color='rgba(255%2c 0%2c 0%2c 0.04)' offset='0.66'%3e%3c/stop%3e%3c/linearGradient%3e%3clinearGradient x1='100%25' y1='100%25' x2='0%25' y2='0%25' id='SvgjsLinearGradient1103'%3e%3cstop stop-color='rgba(255%2c 0%2c 0%2c 0.04)' offset='0'%3e%3c/stop%3e%3cstop stop-opacity='0' stop-color='rgba(255%2c 0%2c 0%2c 0.04)' offset='0.66'%3e%3c/stop%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e")`,
};

export const COLORS = {
  withe: '#ffffff',
  lowWithe: '#fefefe',
  black: '#000000',
  lowBlack: '#202020',
  redMarvel: '#e62429',
  mustard: '#e8b63e',
};
